import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncPrivacyV2 = loadable(() => import("./PrivacyV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncPrivacyV2 {...props} />
  </ErrorBoundary>
);
